import React, { useCallback } from 'react';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import { SIZES } from './constants';
import Icon from '../icon';
import useInteractiveAttributes from '../../hooks/use-interactive-handler';
import IndeterminateTile from './components/indeterminate-tile';
import AaSymbol from './components/aa-symbol';
import { Popover, PopoverTrigger, PopoverContent } from '../popover';
import Paragraph from '../paragraph';
function ColorTile({
  size = SIZES.extraLarge,
  active = false,
  backgroundColor = '#fff',
  indeterminate = false,
  tooltipText = undefined,
  tooltipWidth = undefined,
  fullwidth = false,
  empty = false,
  isDarkTheme = false,
  onConfigureClick = undefined,
  onClick = Function.prototype,
}) {
  const isMobile = bowser.mobile;
  const isTablet = bowser.tablet;
  const isTouchDevice = isMobile || isTablet;
  const isUnspecified =
    !indeterminate && !(backgroundColor && CSS.supports('background', backgroundColor));

  const symbolElement = (
    <div className="ws-ui-color-tile__symbol">
      <AaSymbol isDarkTheme={isDarkTheme} />
    </div>
  );

  const classes = classNames('ws-ui-color-tile', `ws-ui-color-tile--${size}`, {
    'ws-ui-color-tile--active': active,
    'ws-ui-color-tile--indeterminate': indeterminate,
    'ws-ui-color-tile--unspecified': isUnspecified,
    'ws-ui-color-tile--fullwidth': fullwidth,
  });

  const wrapperClasses = classNames(
    'ws-ui-color-tile__wrapper',
    `ws-ui-color-tile__wrapper--${size}`,
    {
      'ws-ui-color-tile__wrapper--fullwidth': fullwidth,
    }
  );

  const onFloatingButtonClick = useCallback(
    (e) => {
      e.stopPropagation();
      onConfigureClick?.();
    },
    [onConfigureClick]
  );

  const interactiveAttributes = useInteractiveAttributes(onClick);

  if (indeterminate) {
    return (
      <IndeterminateTile
        className={classes}
        isTouchDevice={isTouchDevice}
        onClick={onClick}
        tooltipText={tooltipText}
      />
    );
  }

  if (isUnspecified) {
    return <div className={classes} onClick={onClick} {...interactiveAttributes} />;
  }

  if (tooltipText && !isTouchDevice) {
    return (
      <div className={wrapperClasses}>
        <Popover appearance="dark" {...(tooltipWidth && { width: tooltipWidth })}>
          <PopoverTrigger>
            <div
              className={classes}
              onClick={onClick}
              style={{ background: backgroundColor }}
              {...interactiveAttributes}
            >
              {!empty && symbolElement}
              {onConfigureClick && (
                <div
                  className="ws-ui-color-tile__floating-icon-button"
                  onClick={onFloatingButtonClick}
                >
                  <Icon glyph="slider-settings-vertical" size="12" withScaleFactor />
                </div>
              )}
            </div>
          </PopoverTrigger>
          <PopoverContent>
            <Paragraph size="small" appearance="white">
              {tooltipText}
            </Paragraph>
          </PopoverContent>
        </Popover>
      </div>
    );
  }

  return (
    <div
      className={classes}
      onClick={onClick}
      style={{ background: backgroundColor }}
      {...interactiveAttributes}
    >
      {!empty && symbolElement}
      {!isTouchDevice && onConfigureClick && (
        <div className="ws-ui-color-tile__floating-icon-button" onClick={onFloatingButtonClick}>
          <Icon glyph="slider-settings-vertical" size="12" withScaleFactor />
        </div>
      )}
    </div>
  );
}

export default ColorTile;
